// Sensor ekranlarda cədvəlləri barmaqla SAĞA-SOLA sürüşdürmək.
// Səbəb: body-də `touch-action: pan-y` (səhifə yanlara «üzməsin» deyə) brauzerin öz üfüqi
// sürüşdürməsini iç bloklarda da bağlayır → yalnız aşağıdakı nazik scrollbar qalırdı.
// Həll: toxunuşla (touch/pen) üfüqi çəkəndə ən yaxın üfüqi sürüşən bloku özümüz sürüşdürürük.
// Brauzer özü üfüqi sürüşdürə bilirsə pointercancel gəlir → ikiqat sürüşmə olmur.

const SKIP_SELECTOR = 'input[type="range"], [data-no-drag-scroll], canvas';
const THRESHOLD = 8; // px — bu qədər yanlara çəkilməyincə toxunuş klik sayılır

const findHScroller = (el) => {
    for (let n = el; n && n !== document.body && n.nodeType === 1; n = n.parentElement) {
        if (n.scrollWidth > n.clientWidth + 1) {
            const ox = window.getComputedStyle(n).overflowX;
            if (ox === 'auto' || ox === 'scroll') return n;
        }
    }
    return null;
};

export function startTouchDragScroll() {
    let st = null; // { id, x, y, left, scroller, active }

    document.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'touch' && e.pointerType !== 'pen') return;
        if (e.target.closest?.(SKIP_SELECTOR)) return;
        const scroller = findHScroller(e.target);
        if (!scroller) return;
        st = { id: e.pointerId, x: e.clientX, y: e.clientY, left: scroller.scrollLeft, scroller, active: false };
    }, { passive: true });

    document.addEventListener('pointermove', (e) => {
        if (!st || e.pointerId !== st.id) return;
        const dx = e.clientX - st.x;
        const dy = e.clientY - st.y;
        if (!st.active) {
            if (Math.abs(dx) < THRESHOLD) return;
            if (Math.abs(dy) > Math.abs(dx)) { st = null; return; } // şaquli jest → brauzerə burax
            st.active = true;
        }
        st.scroller.scrollLeft = st.left - dx;
    }, { passive: true });

    const end = (e) => {
        if (!st || e.pointerId !== st.id) return;
        const wasDrag = st.active;
        st = null;
        // Sürüşdürmədən sonra barmağı buraxanda altındakı düymə təsadüfən basılmasın
        if (wasDrag) {
            const block = (ev) => { ev.stopPropagation(); ev.preventDefault(); };
            document.addEventListener('click', block, { capture: true, once: true });
            setTimeout(() => document.removeEventListener('click', block, { capture: true }), 350);
        }
    };
    document.addEventListener('pointerup', end, { passive: true });
    document.addEventListener('pointercancel', (e) => { if (st && e.pointerId === st.id) st = null; }, { passive: true });
}
